/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ForcJournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import threeMonthsGoalsJournalEvent from "parog-web/models/three-months-goals-journal-event";

export default class GoalsEditionComponent extends ForcJournalEventBasedComponent {
  static fullComponentId = "lifestyle/goals-edition-form";
  static forcDisplayName = "Objectifs à 3 mois";

  static journalEventClass = threeMonthsGoalsJournalEvent;
  journalEventProperties = ["goals", "occurredAt"];
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel();
    if (this.isNewMode) model.occurredAt = new Date();
    return model;
  }
}
